<template>
  <div class="terminal_message">
    <p>
      <span class="result">【执行命令：({{ index }})】 {{ command }}</span>
      <!--<p class="command"></p>-->
      <span class="result" v-if="canShow">
        {{ success ? '执行成功' : '执行失败, ' + errMsg }}
      </span>
      <span class="result" v-if="expand">
        {{ '提示，' + expand }}
      </span>
    </p>
  </div>
</template>

<script>
export default {
  name: 'TerminalMessage',

  props: {
    index: {
      type: Number,
      required: true
    },
    command: {
      type: String,
      required: true
    },
    success: {
      type: Boolean,
      required: true
    },
    errMsg: {
      type: String
    },
    expand: {
      type: String
    },
    canShow: {
      type: Boolean,
      required: true
    },
  }
};
</script>

<style scoped lang="scss">
.terminal_message {
  font-size: 13px;

  p {
    margin: 18px 0;
  }

  .command {
    font-weight: bold;
  }

  .result {
    font-weight: bold;
    display: inline-block;
    width: 100%;
    margin: 10px 0;
    font-size:  0.83em;
  }
}
</style>
